import api from '@/api'
import CalendarRequest from '@/model/calendar/CalendarRequest'
import CalendarSearchRequest from '@/model/calendar/CalendarSearchRequest'
import { vue } from '@/main';
import moment from '@/libs/vue-moment'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getCalendars(actions, request) {
      return api.base()
        .post('/calendar/get/all', CalendarSearchRequest(request))
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    getEventsByClient(actions, clientId) {
      return api.base()
        .post('/calendar/get/client/'+clientId, )
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    getTodayUpcomingEvents(context){
        return api.base()
            .get('/calendar/get/upcoming')
            .then(
            response => {
                return response.data.data
            },
            err => Promise.reject(err)
            )
    },
    getExternalCalendars(actions, request) {
      return Promise.resolve([])
    },
    getCalendarById(actions, id) {
      return api.base()
        .get('/calendar/id/' + id)
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    addCalendar(actions, calendar) {
      return api.base()
        .post('/calendar/add', CalendarRequest(calendar))
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    updateCalendar(actions, {
      calendar,
      id
    }) {
      return api.base()
        .post('/calendar/update/' + id, CalendarRequest(calendar))
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    updateUserStatus(actions, {
      eventId,
      userId,
      status
    }) {
      return api.base()
        .post(`/calendar/update/${eventId}/user/${userId}`, null, { params: { status: status } })
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    cancelEvent(actions, id) {
      return api.base()
        .delete('/calendar/cancel/' + id)
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    editFromClientModal(actions, { calendar }) {
      return api.base()
        .delete('/calendar/edit/' + calendar.id, CalendarRequest(calendar))
        .then(
          response => {
            return response.data.data
          },
          err => Promise.reject(err)
        )
    },
    notifyToUserEvent(actions, notification) {
      let params = notification.params || {}
      let start = moment.serverDateTime(params.start)
      let title = params.title || null;
      if(params.type === "CALL" || params.type === "MEETING" || params.type === "APPOINTMENT"){
        title = ((params.clientsIds || [])[0] || ['',''])[1]
        title = vue.$t(`calendarTypes.${params.type}.name`) + ' - ' + title
      }
      if(title == null || title === ''){
        title = vue.$t(`calendarTypes.${params.type}.name`)
      }
      let timeout =  moment.serverDateTime(params.end).diff(moment(), 'seconds')
      vue.$emit('system::notification', {
        title: title ,
        message: start.format('LLL'),
        stickId: params.eventId,
        variant: notification.content === 'CALENDAR_REMINDER_EVENT' ? 'info': 'warning',
        icon: 'CalendarIcon',
        timeout
      })
    },
  }
}
